<ng-container *ngIf="isButton && avaliable" >
    <button pButton type="button" pRipple [disabled]="disabled" [label]="label" [icon]="icon" [loading]="isLoading" [class]="buttonClass"
    (click)="authClick()"></button>
</ng-container>
<ng-container *ngIf="!isButton && avaliable">
    <a href="javascript:;" pRipple class="edit-font p-mr-2" (click)="authClick(res)">{{label}}</a>
</ng-container>
